import React from 'react';
import {
  Container,
  HighlightLabel,
  Title,
  Paragraph,
  TitleBlue,
} from './styles';

interface TextMiddleSectionProps {
  title: string;
  titleBlue?: string;
  title2?: string;
  paragraphs: string[];
  maxWidth: string;
  highlightLabel?: string;
}

const TextMiddleSection: React.FC<TextMiddleSectionProps> = ({
  title,
  titleBlue,
  title2,
  paragraphs,
  maxWidth,
  highlightLabel,
}) => {
  return (
    <section>
      <Container maxWidth={maxWidth}>
        {highlightLabel && <HighlightLabel>{highlightLabel}</HighlightLabel>}
        <Title>
          {title} {titleBlue && <TitleBlue>{titleBlue}</TitleBlue>}
          {title2 && <Title>{title2}</Title>}
        </Title>

        {paragraphs.map((paragraph, index) => (
          <Paragraph key={index}>{paragraph}</Paragraph>
        ))}
      </Container>
    </section>
  );
};

export default TextMiddleSection;
